export function extractNumPixelsFromImageFile(file) {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;
      image.onload = () => {
        resolve(image.width * image.height);
      };
      image.onerror = () => reject(new Error('This image type is not permitted'));
    };
    reader.onerror = () => {
      reject(reader.error || new Error('The upload did not complete, please try again.'));
    };
    reader.readAsDataURL(file);
  });
}
